/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLayoutBottombar = createReactComponent("layout-bottombar", "IconLayoutBottombar", [
  [
    "path",
    {
      d: "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z",
      key: "svg-0"
    }
  ],
  ["path", { d: "M4 15l16 0", key: "svg-1" }]
]);

export { IconLayoutBottombar as default };
//# sourceMappingURL=IconLayoutBottombar.js.map
